module.exports = __webpack_public_path__ + "assets/img/37_1556_big.2f00a510.jpg";